import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { signUp } from "../firebase/firebase"; // 👈 Gọi API mới CapacitorHttp
import FrameComponent3 from "../components/FrameComponent3";

const SignIn1 = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const onNgNhpTextClick = useCallback(() => {
    navigate("/21-login");
  }, [navigate]);

  const onFillInfoBackgroundClick = useCallback(async () => {
    if (!name || !email || !pass || !confirmPass) {
      alert("Vui lòng nhập đầy đủ thông tin!");
      return;
    }

    if (pass !== confirmPass) {
      alert("❌ Mật khẩu không khớp!");
      return;
    }

    try {
      // 👉 Gọi API CapacitorHttp signup
      const userData = await signUp(email, pass);
      const userId = userData.localId;

      // 👉 Gửi thêm thông tin user vào Firestore (bằng REST API Firestore)
      await fetch(`https://firestore.googleapis.com/v1/projects/gigitherobot-4550d/databases/(default)/documents/users/${userId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fields: {
            name: { stringValue: name },
            email: { stringValue: email },
            stats: {
              mapValue: {
                fields: {
                  xp: { integerValue: 0 },
                  level: { integerValue: 1 },
                  badges: { arrayValue: { values: [] } },
                }
              }
            },
            createdAt: { timestampValue: new Date().toISOString() }
          }
        })
      });

      alert("✅ Đăng ký thành công!");
      navigate("/41-home");
    } catch (err) {
      console.error(err);
      alert("❌ Đăng ký thất bại: " + (err.message || "Đã có lỗi xảy ra"));
    }
  }, [name, email, pass, confirmPass, navigate]);

  return (
    <div className="min-h-screen w-full bg-light-primary-key-background flex flex-col justify-center items-center px-4 py-8 text-center text-base font-text-regular-lowercase">
      <section className="flex flex-row items-start justify-start pt-0 px-10 pb-[84px] box-border max-w-full text-left text-base text-light-text font-text-regular-lowercase">
        <div className="flex flex-col items-start justify-start gap-10">
          <div
            className="relative font-medium whitespace-pre-wrap cursor-pointer"
            onClick={onNgNhpTextClick}
          >{`<  Đăng nhập`}</div>
          <div className="flex flex-col items-start justify-start gap-[15px] text-21xl text-dark-text">
            <h1 className="m-0 font-semibold">Tạo tài khoản</h1>
            <h3 className="m-0 text-5xl font-semibold text-light-text">
              Bắt đầu hành trình mới!
            </h3>
          </div>
        </div>
      </section>

      {/* NHẬP THÔNG TIN */}
      <div className="w-full px-10 flex flex-col gap-4">
        <input
          className="p-3 rounded-full border border-gray-300"
          placeholder="Tên"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          className="p-3 rounded-full border border-gray-300"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="p-3 rounded-full border border-gray-300"
          placeholder="Mật khẩu"
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
        />
        <input
          className="p-3 rounded-full border border-gray-300 mb-4"
          placeholder="Nhập lại mật khẩu"
          type="password"
          value={confirmPass}
          onChange={(e) => setConfirmPass(e.target.value)}
        />
      </div>

      {/* NÚT ĐĂNG KÝ */}
      <div className="self-stretch flex flex-row items-start justify-start pt-0 px-10 pb-2 box-border max-w-full">
        <div className="h-[60px] flex-1 relative max-w-full">
          <div
            className="absolute top-0 left-0 rounded-81xl bg-gradient-to-r from-pink-400 to-orange-300 w-full h-full cursor-pointer"
            onClick={onFillInfoBackgroundClick}
          />
          <div className="absolute top-[20px] left-[86px] font-medium z-[1] text-white">
            Điền thông tin tài khoản
          </div>
        </div>
      </div>

      {/* ĐIỀU KHOẢN */}
      <div className="px-10 text-sm text-gray-500 text-center w-full">
        <FrameComponent3 />
      </div>
    </div>
  );
};

export default SignIn1;